import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse, HttpEventType } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, retry, map } from 'rxjs/operators';
import { ToastNotificationService } from './toast-notification.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiClient {

  readonly adminApiUrl: string = environment.adminApiUrl;
  readonly portalApiUrl: string = environment.portalApiUrl;

  constructor(private http: HttpClient
    , private notificationService: ToastNotificationService
  ) { }

  prependadminApiUrl(relativeUrl: string): string {
    return this.adminApiUrl + relativeUrl;
  }

  getPrependedUrl(isPublic: boolean) {
    if (isPublic)
      return this.portalApiUrl
    else
      return this.adminApiUrl
  }

  public get<T>(relativeUrl: string, skipNotifications = false, isPublic = false): Observable<T> {
    const url = this.getPrependedUrl(isPublic) + relativeUrl;
    return this.http.get<T>(url)
      .pipe(catchError(err => {
        this.handleError(err, skipNotifications);
        return throwError(err);
      }));

    //.pipe(catchError((err: any) => {
    //  return this.handleError(err, skipNotifications);
    //}));

    // .catch((err: HttpErrorResponse) => {
    //   return this.handleError(err, skipNotifications);
    // });
  }

  //public postForUpload(relativeUrl: string, data: Object, skipNotifications = false) {
  //  const url = this.adminApiUrl + relativeUrl;
  //  return this.http.post<any>(url, data, {
  //    reportProgress: true,
  //    observe: 'events'
  //  }).pipe(map((event) => {

  //    switch (event.type) {

  //      case HttpEventType.UploadProgress:
  //        const progress = Math.round(100 * event.loaded / event.total);
  //        return { status: 'progress', message: progress };

  //      case HttpEventType.Response:
  //        return event.body;
  //      default:
  //        return `Unhandled event: ${event.type}`;
  //    }
  //  })
  //  );
  //}

  //public getForDownload(relativeUrl: string, skipNotifications = false): Observable<HttpResponse<Blob>> {
  //  const url = this.adminApiUrl + relativeUrl;

  //  return this.http.get(url, { responseType: 'blob', observe: 'response' })
  //    .pipe(catchError((err: HttpErrorResponse) => {
  //      return this.handleError(err, skipNotifications);
  //    }));
  //}

  public post<T>(relativeUrl: string, data: Object, skipNotifications = false, headers = null, responseType = null, isPublic = false): Observable<T> {
    const url = this.getPrependedUrl(isPublic) + relativeUrl;
    return this.http.post<T>(url, data, { headers: headers, responseType: responseType })
      .pipe(catchError(err => {
        this.handleError(err, skipNotifications);
        return throwError(err);
      }));
  }

  //public postForDownload(relativeUrl: string, data: Object, skipNotifications = false): Observable<HttpResponse<Blob>> {
  //  const url = this.adminApiUrl + relativeUrl;

  //  return this.http.post(url, data, { responseType: 'blob', observe: 'response' })
  //    .pipe(catchError((err: HttpErrorResponse) => {
  //      return this.handleError(err, skipNotifications);
  //    }));
  //}

  public put<T>(relativeUrl: string, data: Object, skipNotifications = false, isPublic = false): Observable<T> {
    const url = this.getPrependedUrl(isPublic) + relativeUrl;

    return this.http.put<T>(url, data)
      .pipe(catchError(err => {
        this.handleError(err, skipNotifications);
        return throwError(err);
      }));
  }

  //public delete<T>(relativeUrl: string, skipNotifications = false): Observable<T> {
  //  const url = this.adminApiUrl + relativeUrl;

  //  return this.http.delete<T>(url)
  //    .pipe(catchError((err: HttpErrorResponse) => {
  //      return this.handleError(err, skipNotifications);
  //    }));
  //}

  private handleError<T>(operation: any = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error); // log to console instead
      // TODO: collect correct error message from api
      this.notifyError(error);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  //private handleError(err: any, skipError: any): Observable<any> {
  //  console.log(err);
  //  if (!skipError) {
  //    if (!err) {
  //      this.notifyError('An unspecified error occurred.');
  //      return Observable.throw({ message: 'An unspecified error occurred.' });
  //    }
  //    if (err.error) {
  //      this.notifyError(`${err.error.message}`);
  //      return Observable.throw(err.error.message);
  //    }

  //    let msg = `${err.statusText} (${err.status})`;
  //    const help = this.getHelpTextForHttpStatus(err.message);
  //    if (help) {
  //      msg = msg + ` [${help}]`;
  //    }
  //    this.notifyError(msg);
  //  }
  //  return Observable.throw(err);
  //}

  private notifyError(msg: string): void {
    this.notificationService.error(msg);
  }

  private getHelpTextForHttpStatus(status: number): string {
    let help: string;

    switch (status) {
      case 0:
        help = 'The server may be down or unreachable.';
        break;
      case 401:
        help = 'Your login session may have expired.';
        break;
      default:
        help = "";
        break;
    }

    return help;
  }

  public portalGet<T>(relativeUrl: string, skipNotifications = false, isPublic = false): Observable<T> {
    const url = this.getPrependedUrl(isPublic) + relativeUrl;

    return this.http.get<T>(url)
    //.pipe(catchError((err: HttpErrorResponse) => {
    //  return this.handleError(err, skipNotifications);
    //}));

    // .catch((err: HttpErrorResponse) => {
    //   return this.handleError(err, skipNotifications);
    // });
  }
}
